import styles from "./styles.module.css";

const SkeletonItem = () => <div className={styles.skeletonItem} />;

export default SkeletonItem;
